module.exports = __webpack_public_path__ + "img/sqqy_.2d602bce.png";